import {
  CREATE_SMTP_CONFIG,
  CREATE_SMTP_TEST,
  START_LOADING,
  END_LOADING,
  SMTP_ERROR,
} from "../actions/constants";

const initialState = {
  config: {
    host: "",
    port: 587,
    secure: false,
    username: "",
    fromEmail: "",
    password: "",
  },
  TestResult: null,
  loading: false,
  error: null,
};
const emailSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case END_LOADING:
      return {
        ...state,
        loading: false,
      };
    case CREATE_SMTP_CONFIG:
      return {
        ...state,
        config: action.payload,
        loading: false,
        error: null,
      };
    case CREATE_SMTP_TEST:
      return {
        ...state,
        TestResult: action.payload,
        loading: false,
        error: null,
      };
    case SMTP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
export default emailSettingsReducer;
